/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/
import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { PermitAll } from '@csx/security';
import { LmsBaseAppComponent } from '../../core/component/base-app/lms-base-app.component';
import { DataStoreService } from '../../core/services/datastore.service';
import { PopupService } from '../../core/services/popup.service';
import { AppUtilityService } from './../../core/services/app-utility.service';
import { ConfigService } from './../../core/services/config.service';
import { EditModeService } from './../../core/services/edit-mode.service';
import { LmsLoaderService } from './../../core/services/lms-loader.service';
import { LmsMenuService } from './../../core/services/lms-menu.service';
import { LmsModuleService } from './../../core/services/lms-module.service';
import { MessageHandlerService } from './../../core/services/message-handler.service';
import { RouteChangePopupService } from './../../core/services/route-change-popup.service';
import { StaticDataStoreService } from './../../core/services/static-datastore.service';
import { UtilService } from './../../core/services/util.service';
import { NotesDataService } from './../../shared/services/note-data.service';


/**
 * @export
 * @class LmsLocoNotesComponent
 * @extends {LmsBaseAppComponent}
 * @implements {OnInit}
 */
@Component({
  selector: 'lms-loco-notes',
  templateUrl: './loco-notes.component.html',
  styleUrls: ['./loco-notes.component.scss']
})
@PermitAll()
export class LmsLocoNotesComponent extends LmsBaseAppComponent implements OnInit, OnDestroy {

  configdata: any;
  blankMessage: any;
  errorMessage: any;
  noteTextParent: string;


  /**
   * Creates an instance of LmsLocoNotesComponent.
   * @param {NotesDataService} notesDataService
   * @param {LmsModuleService} lmsModuleService
   * @param {ConfigService} configService
   * @param {LmsMenuService} lmsMenuService
   * @param {UtilService} utilService
   * @param {EditModeService} editModeService
   * @param {StaticDataStoreService} staticDataStoreService
   * @param {DataStoreService} dataStoreService
   * @param {RouteChangePopupService} routeChangePopupService
   * @param {FormBuilder} _fb
   * @param {MessageHandlerService} messageHandlerService
   * @param {PopupService} popupService
   * @param {AppUtilityService} appUtilityService
   * @param {LmsLoaderService} lmsLoaderService
   * @memberof LmsLocoNotesComponent
   */
  constructor(private notesDataService: NotesDataService,
    lmsModuleService: LmsModuleService, configService: ConfigService,
    lmsMenuService: LmsMenuService, utilService: UtilService,
    editModeService: EditModeService, private staticDataStoreService: StaticDataStoreService,
    private dataStoreService: DataStoreService,
    routeChangePopupService: RouteChangePopupService, private _fb: UntypedFormBuilder, private messageHandlerService: MessageHandlerService,
    popupService: PopupService, private appUtilityService: AppUtilityService, private lmsLoaderService: LmsLoaderService) {
    super(configService, lmsMenuService, lmsModuleService, utilService, editModeService, routeChangePopupService, popupService);
    this.configdata = this.configService.getConfigData();
    this.service = this.notesDataService;
    this.type = this.configdata.menu.type.locomotive;
    this.blankMessage = this.configdata.notesLabel.searchLocoNotes;
    this.errorMessage = this.configdata.messages.invalidLocomotiveId;
  }

  /**
 * This is used to get data from service and setting the data into our UI used Models
 * @memberOf LmsLocoComponent
 */
  ngOnInit() {
    super.init(this.search);
  }


  /**
  * This method invoked when search for train information is performed.
  * @memberOf LmsTrainComponent
  */
  public search() {
    if (!this.isEditMode()) {
      this.selectedTab.mode = 'view';
      this.updateTab(this.selectedTab);
    }
    this.noteTextParent = '';
    this.notesDataService.load(this.selectedTab, 'LWLD', 'L');
  }

  ngOnDestroy() {
    super.destroy();
  }

}
